<template>
  <div id="V2FooterWrap">
    <div class="footer_wrap">
      <div class="left_box">
        <h1>
          <router-link to="/home">
            <img src="/img/threespace/logo/logo_footer_white.png" />
          </router-link>
        </h1>
        <p>
          <span v-html="$t('menu.address')"></span>
        </p>
        <ul class="footer_menu">
          <li>
            <a href="/terms/terms_of_service" target="_blank">
              {{ $t("menu.terms") }}
            </a>
          </li>
          <li>
            <a href="/terms/privacy_policy" target="_blank">
              {{ $t("menu.privacyPolicy") }}
            </a>
          </li>
          <li>
            <a href="/contact">{{ $t("menu.inquiries") }}</a>
          </li>
        </ul>
      </div>
      <div class="right_box">
        <p>Community</p>
        <ul>
          <li>
            <a href="https://medium.com/@3spaceart" target="_blank">
              MEDIUM
            </a>
          </li>
          <li>
            <a href="https://twitter.com/3spaceart" target="_blank">
              TWITTER
            </a>
          </li>
          <li>
            <a href="https://t.me/threespaceart_chat" target="_blank">
              TELEGRAM
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/3space.art/" target="_blank">
              INSTAGRAM
            </a>
          </li>
          <li>
            <a href="https://github.com/3spaceart" target="_blank">
              GITHUB
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
};
</script>
